<template>
  <Client :mode="mode" />
</template>

<script>
import Client from "./_Client";

export default {
  components: {
    Client
  },
  data: () => ({
    mode: "view"
  })
};
</script>
